import React from 'react';
import { render } from 'react-dom';
import PNCAssessment from './apps/PNCAssessment';

// PNC Assessment
const pncAssessment = document.getElementById('pnc-assessment');
if (pncAssessment)
  render(<PNCAssessment {...pncAssessment.dataset} />, pncAssessment);
